import { Menu } from 'antd';
import React from 'react';
import { MujiLink } from '@souche-f2e/muji';

const { SubMenu } = Menu;

function returnMenuItem(subs) {
  return subs.map(sub => (
    <Menu.Item key={sub.key}>
      {
        sub.url ?
          <MujiLink to={sub.url}>
            {sub.name}
          </MujiLink> :
          sub.name
      }
    </Menu.Item>)
  )
}

function returnSubMenu(subMenuMap, subMenus) {
  return subMenus.map(submunus =>
    <SubMenu key={submunus.key} title={<span>{submunus.name}</span>}>
      {
        returnMenuItem(subMenuMap[submunus.key])
      }
    </SubMenu>
  )
}

export default class DocsSider extends React.Component {
  constructor() {
    super();

    this.state = {
      openKeys: [],
      selectedKeys: []
    };
  }

  handleOpenChange(openKeys) {
    this.setState({
      openKeys
    });
  }

  handleSelectedKeys({ key }) {
    this.setState({
      selectedKeys: [ key ]
    });
  }

  _diff(arr1, arr2) {
    if(arr1.length !== arr2.length) {
      return true;
    }

    for(const item of arr1) {
      if(arr2.indexOf(item) < 0) {
        return true;
      }
    }
    return false;
  }

  union(list) {
    const map = {};
    list = list.filter(item => {
      if(!map[item]) {
        map[item] = true;
        return true;
      }
      return false;
    });
    return list;
  }

  handleDefaultChange(props) {
    let {
      openKeys,
      selectedKeys
    } = this.state;
    const {
      defaultSelectedKeys,
      defaultOpenKeys,
      path
    } = props || this.props;

    if (path && path !== this.oldPath) {

      this.oldPath = path;
      selectedKeys = defaultSelectedKeys;
      openKeys = path === '/documents/docs' ? [] : this.union(openKeys.concat(defaultOpenKeys));

      // 其他地址都是 openKeys 只 union 不 强制刷新
      // 而访问主目录理想的方案是初始化

      this.setState({
        openKeys,
        selectedKeys
      });
    }
  }

  componentWillMount() {
    this.handleDefaultChange()
  }

  componentWillUpdate(nextProps, nextState) {
    this.handleDefaultChange(nextProps, nextState);
  }

  render() {
    const {
      groupMap = {},
      groups = [],
    } = this.props;

    const {
      openKeys,
      selectedKeys
    } = this.state;

    return (
      <Menu
        mode="inline"
        theme="light"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onSelect={(selectedKeys) => { this.handleSelectedKeys(selectedKeys) }}
        onOpenChange={(openKeys) => { this.handleOpenChange(openKeys) }}
        style={{
          marginLeft: 0,
          borderRight: 0,
          width: '280px'
        }}
      >
        {
          returnSubMenu(groupMap, groups)
        }
      </Menu>
    );
  }
}
